import React, { useContext } from 'react';
import * as PropTypes from 'prop-types';

import DropdownListButton from 'ati-ui-react/widgets/DropdownListButton';
import Link from 'ati-ui-react/components/Link';

import i18nStrings from './strings';
import { useLocalized } from 'utils/useLocalized';
import { DataContext } from 'contexts';
import styles from './styles.modules.scss';
import CarTypesOptionsSelector from './CarTypesOptionsSelector';
import CarTypesList from './CarTypesList';

const TruckTypesSelector = ({displayNumber, title, selectedValues, onChange, resetChecked}) => {
    const strings = useLocalized(i18nStrings);
    const data = useContext(DataContext);

    return (
        <div className={styles['element']}>
            <div className={styles['title']}>
                {title}
            </div>

            {Object.keys(data.carTypes || []).length ? (
                <CarTypesOptionsSelector
                    dictionary={data.carTypesArray}
                    selectedValues={selectedValues}
                    onChange={onChange}
                />
            ) : null}

            <div
                className={styles['car-type-button']}
                data-qa="car-type-button"
            >
                <DropdownListButton
                    buttonText={
                        displayNumber
                            ? `${strings.total} ${displayNumber}`
                            : strings.more
                    }
                    gray={!displayNumber}
                    type="pseudo"
                >
                    {Object.keys(data.carTypes || []).length ? (
                        <CarTypesList
                            dictionary={data.carTypesArray}
                            selectedValues={selectedValues}
                            onChange={onChange}
                        />
                    ) : (
                        ''
                    )}
                </DropdownListButton>

                {displayNumber > 0 && (
                    <div className={styles['reset']}>
                        <Link
                            gray
                            small
                            dataQa="car-type-button-reset"
                            type="pseudo"
                            onClick={resetChecked}
                        >
                            {strings.drop}
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TruckTypesSelector;

TruckTypesSelector.propTypes = {
    displayNumber: PropTypes.number,
    resetChecked: PropTypes.func,
    selectedValues: PropTypes.array,
    title: PropTypes.string,
    onChange: PropTypes.func,
};
